module.exports = __webpack_public_path__ + "static/media/overv3.2f9337d2.png";